import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit
} from '@angular/core';
import { CoreApiService } from '../services/core-api.service';
import { ActivatedRoute } from '@angular/router';
import { PlanSummariesByLineOfCoverage } from 'src/app/models/plan-summaries-by-loc';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { DomSanitizer } from '@angular/platform-browser';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { SelectedPlan } from '../models/selected-plan';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';

@Component({
    selector: 'app-plan-confirmation',
    templateUrl: './plan-confirmation.component.html',
    styleUrls: ['./plan-confirmation.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: {
                displayDefaultIndicatorType: false
            }
        }
    ]
})
export class PlanConfirmationComponent implements OnInit, AfterViewInit {
    objectKeys = Object.keys;
    isLoading: boolean = true;
    show: boolean = false;
    locs = [];
    selectedLoc: string;
    index = 0;
    newSelectedIndex: number;
    planSummariesbyLoC: PlanSummariesByLineOfCoverage[] = [];
    planSummariesForVoluntaryLoC: PlanSummariesByLineOfCoverage[] = [];
    quoteList: any = [];
    isQuoteValid: boolean = false;
    validQuote: boolean;
    showText : boolean;

    @ViewChild(MatStepper) stepper: MatStepper;
    loCConfigs = {
        Medical: { stepperView: 'grid' },
        Dental: { stepperView: 'grid' },
        Vision: { stepperView: 'grid' },
        Life: { stepperView: 'grid' },
        Disability: { stepperView: 'grid' },
        Voluntary: { stepperView: 'card' },      
        PetBenefits: { stepperView: 'card' },
        LegalServices: { stepperView: 'card' },
        IdentityProtection: { stepperView: 'card' }
    };

    selectedPlansbyLoC = {
        Medical: [],
        Dental: [],
        Vision: [],
        Life: [],
        Disability: [],
        Voluntary: [],               
        PetBenefits: [],
        LegalServices: [],
        IdentityProtection: []
    };
   
    isSectionComplete = {
        Medical: false,
        Dental: false,
        Vision: false,
        Life: false,
        Disability: false,
        Voluntary: false,     
        PetBenefits: false,
        LegalServices: false,
        IdentityProtection: false
    };

    constructor(
        private api: CoreApiService,
        private route: ActivatedRoute,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private toast: MatSnackBar
    ) {
        this.matIconRegistry.addSvgIcon(
            'medical_case',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/medical-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'dental_tooth',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/dental-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'vision_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/vision-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'life_person',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/life-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'disability_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/disability-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'voluntary_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/voluntary-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'pets_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/pets-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'legal_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/legal-icon.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'cyber_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/cyber-icon.svg'
            )
        );
    }

    openSnackBar() {
        this.toast.openFromComponent(SnackBarComponent, {
            duration: 4000,
            horizontalPosition: 'left',
            verticalPosition: 'bottom'
        });
    }

    ngOnInit() {
        this.showText = false;
        this.loadQuote();
        //this.api.getToken().subscribe({
        //    next: (data) => {
        //        this.api.setCsrf(data.toString());
        //    }         
        //});
    }
        
    loadQuote() {
        console.log("Loading in Plan-Confirmation Component");
        var decryptedQuoteId = this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']);
        console.log("Loading quote for decrypted is :" + decryptedQuoteId);
        return this.api.getQuote(decryptedQuoteId).subscribe((data: {}) => {
            if (data) {
                console.log("Valid Quote");
                return this.validQuote = true;

            } else {
                this.showText = true;
                return this.validQuote = false;
            }
        });
    }

    testSelection(selectedPlans, LoC) {
        this.selectedPlansbyLoC[LoC] = selectedPlans;
    }

    hasPlans(): boolean {
        return (
            !(this.planSummariesbyLoC === undefined
                || this.planSummariesbyLoC === null
                || Object.keys(this.planSummariesbyLoC).length === 0 )
            );
    }

    showHasNoPlans(): boolean {
        return !this.hasPlans() && !this.isLoading;
    }
    
    ngAfterViewInit(): void {
        console.log("GettingPlanSummaries in Plan-Confirmation Component");
        this.api
            .getPlanSummaries(                
                this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']),
                this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId'])
                )
                .subscribe(
                    res => {
                        if (res) {
                            this.planSummariesbyLoC = res;
                            this.planSummariesbyLoC;
                            let selectedIndex = 0;
                            let selectedSection = 'Medical';
                            let selectedPlansArr = [];
                            let offlinePlansArr = [];
                            let i = 0;
                            for (var loc in this.planSummariesbyLoC) {
                                if (this.planSummariesbyLoC.hasOwnProperty(loc)) {
                                    let lv: string = loc;
                                    if (loc === 'HospitalIndemnity' || loc === 'CriticalIllness' || loc === 'Accident') {
                                        if (!this.planSummariesbyLoC.hasOwnProperty("Voluntary")) {
                                            this.planSummariesbyLoC["Voluntary"] = [];
                                        }

                                        switch (loc) {
                                            case "HospitalIndemnity":
                                                loc = "Voluntary";
                                                selectedPlansArr = selectedPlansArr.concat(this.planSummariesbyLoC["HospitalIndemnity"]
                                                    .selectedPlanSummaries);
                                                offlinePlansArr = offlinePlansArr.concat(this.planSummariesbyLoC["HospitalIndemnity"]
                                                    .offlinePlanSummaries);
                                                delete this.planSummariesbyLoC["HospitalIndemnity"];
                                                break;

                                            case "Accident":
                                                loc = "Voluntary";
                                                selectedPlansArr = selectedPlansArr.concat(this.planSummariesbyLoC["Accident"]
                                                    .selectedPlanSummaries);
                                                offlinePlansArr = offlinePlansArr.concat(this.planSummariesbyLoC["Accident"]
                                                    .offlinePlanSummaries);
                                                delete this.planSummariesbyLoC["Accident"];
                                                break;

                                            case "CriticalIllness":
                                                loc = "Voluntary";
                                                selectedPlansArr = selectedPlansArr.concat(
                                                    this.planSummariesbyLoC["CriticalIllness"].selectedPlanSummaries);
                                                offlinePlansArr = offlinePlansArr.concat(
                                                    this.planSummariesbyLoC["CriticalIllness"].offlinePlanSummaries);
                                                delete this.planSummariesbyLoC['CriticalIllness'];
                                                break;

                                            default:
                                                break;
                                        }
                                        this.planSummariesbyLoC["Voluntary"].selectedPlanSummaries = selectedPlansArr;
                                        this.planSummariesbyLoC["Voluntary"].offlinePlanSummaries = offlinePlansArr;
                                    }
                                    if (this.locs.indexOf(loc) === -1) this.locs.push(loc);
                                    this.planSummariesbyLoC[
                                        loc
                                    ].selectedPlanSummaries.forEach(ps => {
                                        if (ps.isSelected) {
                                            this.selectedPlansbyLoC[loc].push(ps);
                                            selectedIndex = i;
                                            selectedSection = loc;
                                        }
                                    });
                                    this.planSummariesbyLoC[
                                        loc
                                    ].offlinePlanSummaries.forEach(ps => {
                                        if (ps.isSelected) {
                                            this.selectedPlansbyLoC[loc].push(ps);
                                            selectedIndex = i;
                                            selectedSection = loc;
                                        }
                                    });
                                    //We do not want to increase the 'i' when its voluntary and its already there in locs list or else we will get index out of bounds error.
                                    if (loc === "Voluntary" && this.locs.indexOf("Voluntary") > -1) {
                                        continue;
                                    } else {
                                        i++;
                                    }

                                }
                            }
                            for (const lc in this.planSummariesbyLoC) {
                                if (this.planSummariesbyLoC.hasOwnProperty(lc)) {
                                    if (lc === selectedSection) {
                                        break;
                                    }
                                    this.isSectionComplete[lc] = true;
                                }
                            }
                            setTimeout(() => {
                                if (this.hasPlans()) {
                                    this.stepper.selectedIndex = selectedIndex;
                                    this.selectedLoc = this.locs[selectedIndex];
                                }
                                this.isLoading = false;
                            }, 2000);
                        } else {
                            console.error(
                                'Invalid Quote ID and no plan summary information returned'
                            );
                            this.openSnackBar();
                        }
                        console.log("Finished Getting PlanSummaries  Plan-Confirmation Component");
                    },
                    error => {
                        console.error(
                            'Error occured while fetching plan summary',
                            error
                        );
                       // this.openSnackBar();
                    }
                );
        }

    sectionState(loc: string) {
        if (this.isSectionComplete[loc] === true) {
           return [loc].toString() + '_complete';
        } else {
            return [loc].toString() + '_incomplete';
        }
    }
    
    // Gets the index of the currently selected step to use for icon overrides
    saveAndContinue(event: StepperSelectionEvent) {
        this.selectedLoc = this.locs[event.selectedIndex];
        let i = 0;
        for (const key in this.selectedPlansbyLoC) {
            if (this.selectedPlansbyLoC.hasOwnProperty(key)) {
                if (i === event.previouslySelectedIndex) {
                    this.isSectionComplete[key] = true;
                    break;
                }
                i++;
            }
        }

        this.sendSelections();
    }
    sendSelections() {
        const data = [];
        for (const loc in this.selectedPlansbyLoC) {
            if (this.selectedPlansbyLoC.hasOwnProperty(loc)) {
                this.selectedPlansbyLoC[loc].map(p =>
                    data.push(new SelectedPlan(p))
                );
            }
        }
        this.api
            .savePlanSelections(
                this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']),
                this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId']),
                'nobody',
                data
            )
            .subscribe(res => {});
    }
}
